import type React from "react";

import { Callout } from "src/design-system/Callout";

export const SqlDatabaseQueryTimeoutsPill: React.FC = () => {
  return (
    <Callout type="info">
      Taktile's ability to successfully probe connections and time out queries
      depends on database configuration
    </Callout>
  );
};
